function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { SCALE_CHANNELS, SHAPE } from '../../channel';
import { getFieldOrDatumDef } from '../../channeldef';
import { channelHasNestedOffsetScale } from '../../encoding';
import { GEOSHAPE } from '../../mark';
import { NON_TYPE_DOMAIN_RANGE_VEGA_SCALE_PROPERTIES, scaleCompatible, scaleTypePrecedence } from '../../scale';
import { GEOJSON } from '../../type';
import { keys } from '../../util';
import { isUnitModel } from '../model';
import { defaultScaleResolve } from '../resolve';
import { mergeValuesWithExplicit, tieBreakByComparing } from '../split';
import { ScaleComponent } from './component';
import { parseScaleDomain } from './domain';
import { parseScaleProperty, parseScaleRange } from './properties';
import { scaleType } from './type';
export function parseScales(model) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    ignoreRange = _ref.ignoreRange;
  parseScaleCore(model);
  parseScaleDomain(model);
  var _iterator = _createForOfIteratorHelper(NON_TYPE_DOMAIN_RANGE_VEGA_SCALE_PROPERTIES),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var prop = _step.value;
      parseScaleProperty(model, prop);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (!ignoreRange) {
    // range depends on zero
    parseScaleRange(model);
  }
}
export function parseScaleCore(model) {
  if (isUnitModel(model)) {
    model.component.scales = parseUnitScaleCore(model);
  } else {
    model.component.scales = parseNonUnitScaleCore(model);
  }
}
/**
 * Parse scales for all channels of a model.
 */
function parseUnitScaleCore(model) {
  var encoding = model.encoding,
    mark = model.mark,
    markDef = model.markDef;
  var scaleComponents = {};
  var _iterator2 = _createForOfIteratorHelper(SCALE_CHANNELS),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var channel = _step2.value;
      var fieldOrDatumDef = getFieldOrDatumDef(encoding[channel]); // must be typed def to have scale
      // Don't generate scale for shape of geoshape
      if (fieldOrDatumDef && mark === GEOSHAPE && channel === SHAPE && fieldOrDatumDef.type === GEOJSON) {
        continue;
      }
      var specifiedScale = fieldOrDatumDef && fieldOrDatumDef.scale;
      if (fieldOrDatumDef && specifiedScale !== null && specifiedScale !== false) {
        specifiedScale !== null && specifiedScale !== void 0 ? specifiedScale : specifiedScale = {};
        var hasNestedOffsetScale = channelHasNestedOffsetScale(encoding, channel);
        var sType = scaleType(specifiedScale, channel, fieldOrDatumDef, markDef, hasNestedOffsetScale);
        scaleComponents[channel] = new ScaleComponent(model.scaleName("".concat(channel), true), {
          value: sType,
          explicit: specifiedScale.type === sType
        });
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return scaleComponents;
}
var scaleTypeTieBreaker = tieBreakByComparing(function (st1, st2) {
  return scaleTypePrecedence(st1) - scaleTypePrecedence(st2);
});
function parseNonUnitScaleCore(model) {
  var _a;
  var scaleComponents = model.component.scales = {};
  var scaleTypeWithExplicitIndex = {};
  var resolve = model.component.resolve;
  // Parse each child scale and determine if a particular channel can be merged.
  var _iterator3 = _createForOfIteratorHelper(model.children),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var child = _step3.value;
      parseScaleCore(child);
      // Instead of always merging right away -- check if it is compatible to merge first!
      var _iterator5 = _createForOfIteratorHelper(keys(child.component.scales)),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _a$channel;
          var channel = _step5.value;
          // if resolve is undefined, set default first
          (_a$channel = (_a = resolve.scale)[channel]) !== null && _a$channel !== void 0 ? _a$channel : _a[channel] = defaultScaleResolve(channel, model);
          if (resolve.scale[channel] === 'shared') {
            var explicitScaleType = scaleTypeWithExplicitIndex[channel];
            var childScaleType = child.component.scales[channel].getWithExplicit('type');
            if (explicitScaleType) {
              if (scaleCompatible(explicitScaleType.value, childScaleType.value)) {
                // merge scale component if type are compatible
                scaleTypeWithExplicitIndex[channel] = mergeValuesWithExplicit(explicitScaleType, childScaleType, 'type', 'scale', scaleTypeTieBreaker);
              } else {
                // Otherwise, update conflicting channel to be independent
                resolve.scale[channel] = 'independent';
                // Remove from the index so they don't get merged
                delete scaleTypeWithExplicitIndex[channel];
              }
            } else {
              scaleTypeWithExplicitIndex[channel] = childScaleType;
            }
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
    // Merge each channel listed in the index
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  var _iterator4 = _createForOfIteratorHelper(keys(scaleTypeWithExplicitIndex)),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _channel = _step4.value;
      // Create new merged scale component
      var name = model.scaleName(_channel, true);
      var typeWithExplicit = scaleTypeWithExplicitIndex[_channel];
      scaleComponents[_channel] = new ScaleComponent(name, typeWithExplicit);
      // rename each child and mark them as merged
      var _iterator6 = _createForOfIteratorHelper(model.children),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _child = _step6.value;
          var childScale = _child.component.scales[_channel];
          if (childScale) {
            _child.renameScale(childScale.get('name'), name);
            childScale.merged = true;
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  return scaleComponents;
}